<template>
  <div class="pdf-content-new">
    <div class="hasPdf" v-if="src">
      <div class="btn-content" v-if="canReupload">
        <el-upload
          class="upload_btn"
          ref="upload"
          action="/api/emer/plandoc/upload"
          :on-progress="onprogress"
          :headers="headers"
          :data="datalist"
          :on-success="onSuccess"
          :on-error="onError"
          accept=".xls,.xlsx,.doc,.docx,.txt,.pdf"
          :on-change="onChange"
          :beforeUpload="beforeUpload"
        >
          <el-tooltip content="只允许上传.xls,.xlsx,.doc,.docx,.txt,.pdf格式文件,若上传后显示异常，请转为pdf后再上传" placement="top" effect="light">
            <i class="iconfont icon-shangchuan">
              <a>重新上传</a></i>
          </el-tooltip>
        </el-upload>
      </div>
      <iframe :src="'/static/pdf/web/viewer.html?file=' + encodeURIComponent(src)" width="100%" height="100%"></iframe>
    </div>
    <div class="noPdf" v-else>
      <div class="btn-content" v-if="canReupload">
        <el-upload
          class="upload_btn"
          ref="upload"
          action="/api/emer/plandoc/upload"
          :on-progress="onprogress"
          :headers="headers"
          :data="datalist"
          :on-success="onSuccess"
          :on-error="onError"
          accept=".xls,.xlsx,.doc,.docx,.txt,.pdf"
          :on-change="onChange"
          :beforeUpload="beforeUpload"
        >
          <el-tooltip content="只允许上传.xls,.xlsx,.doc,.docx,.txt,.pdf格式文件,若上传后显示异常，请转为pdf后再上传" placement="top" effect="light">
            <i class="iconfont icon-shangchuan">
              <a>上传</a></i>
          </el-tooltip>
        </el-upload>
        <div class="download-tips" v-if="datalist.type === 1 || datalist.type === 51">
          <div class="download-tips-content">
            <i class="el-alert__icon el-icon-warning is-big"></i>
            <p class="download-tips-infos">请使用2020年最新的备案表，否则无法通过备案</p>
            <em class="download-tips-button" @click="downloadTemplate">下载备案表模板</em>
          </div>
        </div>
        <div class="new-download-tips" v-if="datalist.type === 1000">
          <div class="download-tips-content">
            <i class="el-alert__icon el-icon-warning is-big"></i>
            <em class="download-tips-button" @click="downloadSimplifyTemplate">下载简化备案表模板</em>
          </div>
        </div>
        <div class="new-download-tips" v-if="datalist.type === 1001">
          <div class="download-tips-content">
            <i class="el-alert__icon el-icon-warning is-big"></i>
            <em class="download-tips-button" @click="downloadPromiseCardTemplate">下载环境安全责任承诺卡模板</em>
          </div>
        </div>
        <div class="new-download-tips" v-if="datalist.type === 1002">
          <div class="download-tips-content">
            <i class="el-alert__icon el-icon-warning is-big"></i>
            <em class="download-tips-button" @click="downloadRetrospectionTemplate">下载回顾性评估表模板</em>
          </div>
        </div>
        <p>只允许上传.xls,.xlsx,.doc,.docx,.txt,.pdf格式文件</p>
        <p>若上传后显示异常，请转为pdf后再上传</p>
      </div>
    </div>
    <!-- 上传进度条展示 -->
    <el-dialog title='文件上传中' :visible.sync="uploadVisable" size="tiny" style="text-align:center">
      <el-progress type="circle" :percentage="percent"></el-progress>
      <span slot="footer" class="dialog-footer">
				<el-button @click="abort();uploadVisable = false">终止上传</el-button>
			</span>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from "vue";
  export default {
    name: 'pdfNew',
    data () {
      return {
        datalist: {
          type: "",
          planId: null
        },
        isLoading:false,
        loadedRatio:0,
        percent:0,
        uploadVisable:false,

      }
    },
    props: {
      src: {
        type: String
      },
      activeData: {
        type: Object
      },
      canReupload: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      activeData() {
        console.log(this.activeData);
        this.datalist.type = this.activeData.type;
      },
      src() {
        console.log(this.src)
      },

      uploadVisable() {
        if(!this.uploadVisable){
          this.$refs.upload.abort();
        }
      }
    },

    mounted() {
      if (!this.activeData) {
        return;
      } else {
        this.datalist.type = this.activeData.type;
      }
      this.datalist.planId = sessionStorage.planIdval;
    },
    created(){
      var that = this;
    },

    methods:{
      downloadTemplate () {
        this.$emit('downloadTemplate')
      },
      downloadPromiseCardTemplate(){
        this.$emit('downloadPromiseCardTemplate')
      },
      downloadRetrospectionTemplate(){
        this.$emit('downloadRetrospectionTemplate')
      },
      downloadSimplifyTemplate(){
        console.log('sessionStorage')
        this.$emit('downloadSimplifyTemplate')
      },
      beforeUpload(file){
        var filtType=file.name.substring(file.name.lastIndexOf('.')+1)
        if(filtType.toLowerCase() =='xls'
          || filtType.toLowerCase() =='xlsx'
          || filtType.toLowerCase() =='doc'
          || filtType.toLowerCase() =='docx'
          || filtType.toLowerCase() =='txt'
          || filtType.toLowerCase() =='pdf'){

        }else{
          this.$refs.upload.abort();
          this.$message.error("只允许上传.xls,.xlsx,.doc,.docx,.txt,.pdf格式文件");
          return false

        }

      },
      onprogress(event, file, fileList){
        this.uploadVisable = true;
        this.percent = parseInt(event.percent);
      },
      loadPdfHandler(){
        this.isLoading = false;
      },
      //终止上传
      abort() {
        try {
          this.$refs.upload.abort();
          this.$message.success("终止上传成功");
        } catch (error) {
          this.$message.error("终止上传失败");
        }
      },
      // 上传成功
      onSuccess(fileList, fil) {
        this.uploadVisable = false;
        this.percent = 0;
        this.$emit("changeFile", fileList);
      },
      onError(err) {
        try {
          let error = err.toString();
          let msg = error.substring(error.indexOf("{"), error.indexOf("}") + 1);
          this.uploadVisable = false;
          this.percent = 0;
          this.$emit("onError", JSON.parse(msg).message);
        } catch (error) {
          this.uploadVisable = false;
          this.percent = 0;
          this.$emit("onError", "文件上传失败，请稍候重试");
        }
      },
      onChange() {
        // this.$emit("onChange");
      },

    },

    computed: {
      headers() {
        return {
          Authorization: "Bearer " + sessionStorage.getItem("publicToken")
        };
      }
    },
    destroy() {
      this.activeData = "";
    }
  }
</script>


<style scoped>
  .pdf-content-new,
  .hasPdf,
  .noPdf{
    width:100%;
    height: 600px;
    position: relative;
  }

  .hasPdf .btn-content {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 100;
    background-color: rgba(0,0,0,.7);
    border-radius: 100%;
    color:#fff;
    width: 65px;
    height: 65px;
    line-height: 20px;
    text-align: center;
    border:2px solid rgba(255,255,255,.7);
  }

  .hasPdf .btn-content a {
    color:#fff;
    font-size: 12px;
    display: block;
    cursor: pointer;
  }

  .hasPdf .upload_btn {
    margin-top: 10px;
  }

  .noPdf .btn-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
  }

  .noPdf .btn-content a{
    color:#fff;
    font-size: 14px;
    cursor: pointer;
  }

  .noPdf .btn-content p{
    color:#999;
    font-size: 14px;
  }

  .noPdf .upload_btn {
    display: inline-block;
    color: #fff;
    background-color: #20a0ff;
    border-color: #20a0ff;
    padding: 10px 15px;
    border-radius: 4px;
    line-height: 21px;
  }

  .download-tips {
    background: repeating-linear-gradient(135deg, transparent, transparent 3px, #e6a23c 3px, #e6a23c 8px);
    color: #e6a23c;
    animation: shine 1s infinite linear;
    width: 100%;
    padding: 1px;
    margin: 20px auto;
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    display: flex;
    opacity: 1;
    align-items: center;
    transition: opacity .2s;
  }

  .new-download-tips {
    background: repeating-linear-gradient(135deg, transparent, transparent 3px, #e6a23c 3px, #e6a23c 8px);
    color: #e6a23c;
    animation: shine 1s infinite linear;
    width: 100%;
    padding: 1px;
    margin: 20px auto;
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    //display: flex;
    opacity: 1;
    align-items: center;
    transition: opacity .2s;
  }

  @keyframes shine {
    0% { background-position: -1px -1px;}
    100% { background-position: -12px -12px;}
  }

  .noPdf .btn-content .download-tips .download-tips-content {
    padding: 8px 16px;
    background-color: #ffffff;
  }

  .noPdf .btn-content .new-download-tips .download-tips-content {
    padding: 8px 16px;
    background-color: #ffffff;
  }
  .noPdf .btn-content .new-download-tips .download-tips-button{
    cursor: pointer;
    color: #20a0ff;
    font-weight: bold;
    text-decoration: underline;
  }

  .noPdf .btn-content .download-tips .download-tips-infos {
    color: #e6a23c;
    margin-bottom: 5px;
  }
  .noPdf .el-alert__icon.is-big {
    display: inline-block;
    margin-bottom: 5px;
    color: #e6a23c;
  }
  .noPdf .btn-content .download-tips .download-tips-button{
    cursor: pointer;
    color: #20a0ff;
    font-weight: bold;
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// pdfNew.vue?2ca1fa88